"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingContent = void 0;
const React = require("react");
const react_transition_group_1 = require("react-transition-group");
const cssTransitions_1 = require("../../../../helpers/cssTransitions");
const Loader_1 = require("../../atoms/Loader");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles);
/**
 * Prevents part of the app from showing unless a condition is met. Provides
 * styling to allow the child components to be layered ontop of each other.
 */
const PendingContent = ({ check, fallback = null, transition, transitionChildren = {}, className = false, children = null, isLocalised = false, renderChildrenWhilePending = false }) => {
    // allow someone to pass null
    fallback = fallback ? fallback : () => React.createElement(Loader_1.LoadingOverlay, { size: "lg" });
    // default the transtions. Cannot be done in the props definition above.
    transition = transition ? transition : cssTransitions_1.defaultTransition;
    // by default, no transition for underlying element
    transitionChildren = transitionChildren ? transitionChildren : cssTransitions_1.noTransition;
    className = className ? className : css("protectedArea");
    return (React.createElement(react_transition_group_1.TransitionGroup, { className: className, component: "div" },
        check && (React.createElement(react_transition_group_1.CSSTransition, { classNames: transitionChildren, timeout: 500, key: "success" },
            React.createElement("div", { className: css("protectedArea_container"), "data-test": "content" }, children))),
        !check && (React.createElement(react_transition_group_1.CSSTransition, { classNames: transition, timeout: 500, key: "fallback" },
            React.createElement("div", { className: css(`protectedArea_${isLocalised ? "localised" : "fallback"}`), "data-test": "fallback" },
                renderChildrenWhilePending && children,
                React.createElement(fallback, {}))))));
};
exports.PendingContent = PendingContent;
// TODO - legacy
exports.default = exports.PendingContent;
//# sourceMappingURL=index.js.map